import { parseStrategyFromApi } from 'app/pages/system/warehouses/OptimizationStrategies/OptimizationStrategies.utils';
import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { OPTIMIZATION_STRATEGY_ACTION_TYPE } from '../actions';

const initialState = {
  strategies: [],
};

const parseStrategies = data => (data || []).map(parseStrategyFromApi);

const optimizationStrategiesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case OPTIMIZATION_STRATEGY_ACTION_TYPE.GET_STRATEGIES:
        draft.strategies = parseStrategies(payload);
        break;

      case OPTIMIZATION_STRATEGY_ACTION_TYPE.CREATE_STRATEGY:
        draft.strategies.push(parseStrategyFromApi(payload));
        break;

      case OPTIMIZATION_STRATEGY_ACTION_TYPE.UPDATE_STRATEGY:
        draft.strategies = draft.strategies.map(strategy =>
          strategy.id === payload.id ? parseStrategyFromApi(payload) : strategy,
        );
        break;

      case OPTIMIZATION_STRATEGY_ACTION_TYPE.DELETE_STRATEGY:
        draft.strategies = draft.strategies.filter(strategy => strategy.id !== meta?.strategyId);
        break;

      case OPTIMIZATION_STRATEGY_ACTION_TYPE.SET_ACTIVE_STRATEGY:
        draft.strategies = draft.strategies.map(strategy => ({
          ...strategy,
          isActive: strategy.id === meta?.strategyId,
        }));
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default optimizationStrategiesReducer;
